var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "div",
              { staticClass: "single singleItem container-flex page-content" },
              [
                _vm.$store.state.items.isAddToBasketLoading != 0
                  ? _c(
                      "div",
                      { staticClass: "item-loading-splash-screen" },
                      [
                        _c("icon", {
                          attrs: {
                            icon: "spinner",
                            loading:
                              _vm.$store.state.items.isAddToBasketLoading != 0,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "bg-white" }, [
                  _c("div", { staticClass: "container-max" }, [
                    _c(
                      "div",
                      { staticClass: "row position-relative" },
                      [
                        _vm._t("breadcrumb"),
                        _vm._v(" "),
                        !_vm.desktop
                          ? _c(
                              "div",
                              { staticClass: "singleItemName resMob" },
                              [
                                _c("h1", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.name1
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "feedbackTags" },
                                  [
                                    _c(
                                      "client-only",
                                      [
                                        _c("feedback-average", {
                                          staticClass: "box-feedback",
                                          attrs: {
                                            "show-empty-ratings": false,
                                            "size-of-stars": "small",
                                            "show-ratings-amount": true,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.hasPropertySelection(166, 397)
                                      ? _c(
                                          "span",
                                          { staticClass: "tag tagFavorit" },
                                          [_vm._v("Bestseller")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.currentVariation.tags,
                                      function (tag) {
                                        return [130, 131, 132, 133].includes(
                                          tag.id
                                        )
                                          ? [
                                              _c("span", {
                                                class:
                                                  "scrollTo tag tagSize" +
                                                  (parseInt(tag.id) - 129),
                                                attrs: { target: "#sizeTable" },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    tag.names.name
                                                  ),
                                                },
                                              }),
                                            ]
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-7 singleItemImage text-center mb-2",
                          },
                          [
                            _vm._t("image-carousel"),
                            _vm._v(" "),
                            _vm.model3d != ""
                              ? _c(
                                  "client-only",
                                  [
                                    _c("three-viewer", {
                                      attrs: {
                                        model: _vm.model3d,
                                        "animation-scale":
                                          _vm.model3dAnimationSpeed,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.getProperty(192), function (property) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "modal fade",
                                    attrs: {
                                      id: "videoModal",
                                      tabindex: "-1",
                                      "aria-labelledby": "Youtube Video",
                                      "aria-hidden": "true",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "modal-dialog" }, [
                                      _c(
                                        "div",
                                        { staticClass: "modal-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "modal-body" },
                                            [
                                              _c("iframe", {
                                                attrs: {
                                                  id: "ytplayer",
                                                  type: "text/html",
                                                  width: "100%",
                                                  height: "400px",
                                                  src:
                                                    "https://www.youtube.com/embed/" +
                                                    property.values.value +
                                                    "?autoplay=0&modestbranding=1",
                                                  frameborder: "0",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-5 singleItemDetails single-rightside mb-2",
                          },
                          [
                            _vm._t("admin-form-cartcross"),
                            _vm._v(" "),
                            _vm.desktop
                              ? _c("div", { staticClass: "singleItemName" }, [
                                  _c("h1", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.texts.name1
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "feedbackTags" },
                                    [
                                      _c("feedback-average", {
                                        staticClass: "box-feedback",
                                        attrs: {
                                          "show-empty-ratings": false,
                                          "size-of-stars": "small",
                                          "show-ratings-amount": true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.hasPropertySelection(166, 397)
                                        ? _c(
                                            "span",
                                            { staticClass: "tag tagFavorit" },
                                            [_vm._v("Bestseller")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.currentVariation.tags,
                                        function (tag) {
                                          return [130, 131, 132, 133].includes(
                                            tag.id
                                          )
                                            ? [
                                                _c("span", {
                                                  class:
                                                    "scrollTo tag tagSize" +
                                                    (parseInt(tag.id) - 129),
                                                  attrs: {
                                                    target: "#sizeTable",
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      tag.names.name
                                                    ),
                                                  },
                                                }),
                                              ]
                                            : _vm._e()
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("bkAddToWishlist", {
                              attrs: {
                                "variation-id":
                                  _vm.currentVariation.variation.id,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  {
                                    class:
                                      "availabilityRow availabilityRow_" +
                                      _vm.currentVariation.variation
                                        .availability.id,
                                  },
                                  [
                                    _c("biokinder-availability", {
                                      attrs: {
                                        avd: _vm.$attrs.availabilitydata,
                                        variation:
                                          _vm.currentVariation.variation,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.attributes.length
                                  ? _c(
                                      "div",
                                      { staticClass: "mb-3 variationSelect" },
                                      [_c("variation-select")],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.filter.isSalable &&
                                _vm.variationGroupedProperties.length
                                  ? _c(
                                      "div",
                                      { staticClass: "row mb-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-12" },
                                          [_c("order-property-list")],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._t("aufbauservice"),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._t("before-price"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "singleartprice mb-3",
                                    attrs: {
                                      itemprop: "offerDetails",
                                      itemscope: "",
                                      itemtype:
                                        "http://data-vocabulary.org/Offer",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "variationManufacturer",
                                        attrs: {
                                          "data-toggle": "collapse",
                                          "aria-expanded": "false",
                                          "data-target": "#manufacturer",
                                        },
                                      },
                                      [
                                        _vm.currentVariation.item.manufacturer
                                          .id &&
                                        _vm.currentVariation.item.manufacturer
                                          .logo
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.currentVariation.item
                                                  .manufacturer.logo,
                                                alt:
                                                  "Marken-Logo-" +
                                                  _vm.currentVariation.item
                                                    .manufacturer.externalName,
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "variationPrice" },
                                      [
                                        _c("graduated-prices"),
                                        _vm._v(" "),
                                        _c("item-price"),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: {
                                            type: "hidden",
                                            id: "stdShippingCosts",
                                          },
                                          domProps: {
                                            value:
                                              _vm.currentVariation.variation
                                                .defaultShippingCosts,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.currentVariation.prices.default
                                          .price &&
                                        _vm.currentVariation.prices.default
                                          .price.value > 200
                                          ? _vm._t("before-add-to-basket")
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.reducedPrice &&
                                _vm.bkconfig.shopSale.showItemPage == "true" &&
                                (_vm.bkconfig.shopSale.itemPageMode == 0 ||
                                  (_vm.bkconfig.shopSale.itemPageMode == 1 &&
                                    _vm.currentVariation.item.manufacturer.id ==
                                      17)) &&
                                !_vm.itemsCouponDisabled.includes(
                                  _vm.currentVariation.item.id
                                ) &&
                                !_vm.hasFixedPrice
                                  ? [
                                      _c(
                                        "client-only",
                                        [
                                          _c("sales-coupon", {
                                            attrs: {
                                              code: _vm.bkconfig.shopSale
                                                .coupon,
                                              showvalid: false,
                                              icon:
                                                _vm.bkconfig.shopSale
                                                  .showIconOnSingleItem ===
                                                "true",
                                              moreinfo:
                                                "- " +
                                                _vm.$options.filters.currency(
                                                  _vm.currentVariation.prices
                                                    .default.price.value *
                                                    _vm.bkconfig.shopSale
                                                      .singleItemFactor,
                                                  _vm.currentVariation.prices
                                                    .default.currency
                                                ) +
                                                " mit dem Code:",
                                              short: true,
                                              details: true,
                                              enddate:
                                                _vm.bkconfig.shopSale.enddate,
                                              countdown:
                                                _vm.bkconfig.shopSale
                                                  .defaultCountdownText,
                                              "countdown-position": 0,
                                              "short-headline":
                                                _vm.bkconfig.shopSale
                                                  .shortHeadline,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("add-to-basket", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id,
                                    "is-salable":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-children":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter
                                        .hasActiveChildren,
                                    "interval-quantity":
                                      _vm.currentVariation.variation
                                        .intervalOrderQuantity || 1,
                                    "minimum-quantity":
                                      _vm.currentVariation.variation
                                        .minimumOrderQuantity,
                                    "maximum-quantity":
                                      !!_vm.currentVariation.variation
                                        .maximumOrderQuantity &&
                                      _vm.currentVariation.variation
                                        .maximumOrderQuantity > 0
                                        ? _vm.currentVariation.variation
                                            .maximumOrderQuantity
                                        : null,
                                    "order-properties":
                                      _vm.currentVariation.properties.filter(
                                        function (prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                    "use-large-scale": false,
                                    "show-quantity": true,
                                    "item-url": _vm._f("itemURL")(
                                      _vm.currentVariation
                                    ),
                                    "is-variation-selected":
                                      _vm.isVariationSelected &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-price": _vm._f("hasItemDefaultPrice")(
                                      _vm.currentVariation
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _vm.hasProperty(292) &&
                                    _vm.crossSellingCategoryId > 0
                                      ? _c("slide-content", {
                                          attrs: {
                                            name: "crossselling",
                                            "variation-id":
                                              _vm.currentVariation.variation.id,
                                            "category-id":
                                              _vm.crossSellingCategoryId,
                                          },
                                        })
                                      : _vm.hasCartCrossSelling
                                      ? _c("slide-content", {
                                          attrs: {
                                            name: "crossselling",
                                            "cart-cross-selling": true,
                                            "variation-id":
                                              _vm.currentVariation.variation.id,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "content",
                                                fn: function () {
                                                  return [
                                                    _vm._t("autocross"),
                                                    _vm._v(" "),
                                                    _vm._t(
                                                      "cross-selling-cart"
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._t(
                                      "additional-content-after-add-to-basket"
                                    ),
                                    _vm._v(" "),
                                    _vm.hasProperty(193)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "audioPlayer",
                                            attrs: {
                                              id: "audioPlayerContainer",
                                            },
                                          },
                                          [
                                            _vm._l(
                                              _vm.getProperty(193),
                                              function (prop) {
                                                return prop.values.value != ""
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "title" },
                                                      [
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              prop.values.value
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e()
                                              }
                                            ),
                                            _vm._v(" "),
                                            _vm._m(0),
                                            _vm._v(" "),
                                            _vm._m(1),
                                            _vm._v(" "),
                                            _vm._m(2),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.getProperty(194),
                                              function (prop) {
                                                return prop.values.value != ""
                                                  ? _c(
                                                      "audio",
                                                      {
                                                        attrs: {
                                                          id: "audioPlayer",
                                                        },
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: prop.values
                                                              .value,
                                                            type: "audio/mp3",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e()
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._t("beaver"),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.hasProperty(166)
                                  ? _c(
                                      "div",
                                      { staticClass: "siegelContainer" },
                                      [
                                        _vm.hasPropertySelection(166, 346)
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "/textseiten/natuerliche-rohstoffe/",
                                                  alt: "Natürliche Rohstoffe",
                                                  "aria-label":
                                                    "Natürliche Rohstoffe",
                                                  "click-count": "",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: "https://cdn.bio-kinder.de/frontend/seals/natural.svg",
                                                    alt: "Natürliche Rohstoffe",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 275)
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "/textseiten/bio-erlenholzmoebel-kindermoebel-fuer-babys-und-kinder/",
                                                  "aria-label": "Bio-Erlenholz",
                                                  alt: "Bio-Erlenholz",
                                                  "click-count": "",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: "https://cdn.bio-kinder.de/frontend/seals/alderwood.svg",
                                                    alt: "100% Bio-Erlenholz",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 449)
                                          ? _c("img", {
                                              attrs: {
                                                src: "https://cdn.bio-kinder.de/frontend/seals/oak.svg",
                                                alt: "Bio-Eichenholz",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 276)
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "/textseiten/bio-kiefernholz-von-bio-kinder/",
                                                  "aria-label":
                                                    "Bio-Kiefernholz",
                                                  alt: "Bio-Kiefernholz",
                                                  "click-count": "",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: "https://cdn.bio-kinder.de/frontend/seals/pinewood.svg",
                                                    alt: "100% Bio-Kiefernholz",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 345)
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "/content/10-jahre-garantie/",
                                                  "aria-label": "Möbelgarantie",
                                                  alt: "Möbelgarantie",
                                                  "click-count": "",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: "https://cdn.bio-kinder.de/frontend/seals/guarantee.svg",
                                                    alt: "10 Jahre Möbel-Garantie",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 344)
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "/content/100-fair-produziert/",
                                                  "aria-label":
                                                    "Fair produziert",
                                                  alt: "Fair produziert",
                                                  "click-count": "",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: "https://cdn.bio-kinder.de/frontend/seals/fair.svg",
                                                    alt: "Fair produziert",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 403)
                                          ? _c("img", {
                                              attrs: {
                                                src: "https://cdn.bio-kinder.de/frontend/seals/organictreewool.svg",
                                                alt: "kbA Baumwolle",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 404)
                                          ? _c("img", {
                                              attrs: {
                                                src: "https://cdn.bio-kinder.de/frontend/seals/sheepwool.svg",
                                                alt: "100% Schurwolle",
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasProperty(166)
                                  ? _c(
                                      "div",
                                      { staticClass: "siegelContainer" },
                                      [
                                        _vm.hasPropertySelection(166, 274)
                                          ? _c("img", {
                                              staticClass: "bioolaLogo",
                                              attrs: {
                                                "data-toggle": "modal",
                                                "data-target": "#bioola",
                                                src: "https://cdn.bio-kinder.de/frontend/assets/bioola/bioola.svg",
                                                alt: "bioola Lasur",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 622)
                                          ? _c("img", {
                                              staticClass: "softCloseLogo",
                                              attrs: {
                                                src: "https://cdn.bio-kinder.de/frontend/seals/soft_close.svg",
                                                alt: "Soft-Close",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 617)
                                          ? _c("img", {
                                              attrs: {
                                                src: "https://cdn.bio-kinder.de/frontend/seals/din1729.svg",
                                                alt: "DIN geprueft",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasPropertySelection(166, 652)
                                          ? _c("img", {
                                              staticStyle: {
                                                "max-height": "80px",
                                              },
                                              attrs: {
                                                src: "https://cdn.bio-kinder.de/frontend/images/icons/made_in_germany.svg",
                                                alt: "Hergestellt in Deutschland",
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          2
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "container-max" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-7" }, [
                        _c(
                          "section",
                          { staticClass: "descriptionContainer tmplt" },
                          [
                            _c("span", {
                              staticClass: "containerHeading",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemDescription"
                                  )
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _vm.hasProperty(290)
                              ? _c("div", {
                                  staticClass: "descriptionContent",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getProperty(290)[0]?.values.value
                                    ),
                                  },
                                })
                              : _c("div", {
                                  staticClass: "descriptionContent",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.description
                                    ),
                                  },
                                }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "aside",
                        { staticClass: "col-md-5", attrs: { id: "rightSide" } },
                        [
                          _c(
                            "section",
                            {
                              staticClass: "descriptionContainer shippingInfo",
                            },
                            [
                              _c("biokinder-shipping-icon", {
                                attrs: {
                                  variation: _vm.currentVariation.variation,
                                  avd: _vm.$attrs.availabilitydata,
                                  availability:
                                    _vm.currentVariation.variation
                                      .availabilityId,
                                  shipping: _vm.calcDefaultShippingCosts,
                                  countryId: _vm.shippingCountryId,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hasProperty(197)
                            ? [
                                _c(
                                  "section",
                                  {
                                    staticClass:
                                      "descriptionContainer instagram",
                                  },
                                  [
                                    _c("instagram-gallery", {
                                      attrs: {
                                        "variation-id":
                                          _vm.currentVariation.variation.id,
                                        caption:
                                          _vm.currentVariation.texts.name1,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showBundleComponents
                            ? [
                                _c(
                                  "section",
                                  {
                                    staticClass: "descriptionContainer",
                                    attrs: { id: "bundleDetail" },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-block text-left descriptionButton collapsed",
                                        attrs: {
                                          "data-toggle": "collapse",
                                          "data-target": "#bundleComponents",
                                          "aria-expanded": "false",
                                          "aria-controls": "bundleComponents",
                                          "aria-label":
                                            "Paketbestandteile anzeigen",
                                          "click-count": "",
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass: "icon-bundle",
                                            attrs: {
                                              viewBox: "0 0 24 24",
                                              width: "22",
                                              height: "22",
                                              stroke: "currentColor",
                                              "stroke-width": "1.5",
                                              fill: "none",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                            },
                                          },
                                          [
                                            _c("line", {
                                              attrs: {
                                                x1: "16.5",
                                                y1: "9.4",
                                                x2: "7.5",
                                                y2: "4.21",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("polyline", {
                                              attrs: {
                                                points:
                                                  "3.27 6.96 12 12.01 20.73 6.96",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("line", {
                                              attrs: {
                                                x1: "12",
                                                y1: "22.08",
                                                x2: "12",
                                                y2: "12",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v("In diesem Set enthalten"),
                                        ]),
                                        _vm._v(" "),
                                        _c("i", {
                                          attrs: { "data-feather": "plus" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "collapse mt-1",
                                        attrs: {
                                          id: "bundleComponents",
                                          "aria-labelledby": "bundleComponents",
                                          "data-parent": "#rightSide",
                                        },
                                      },
                                      _vm._l(
                                        _vm.currentVariation.bundleComponents,
                                        function (bundleComponent) {
                                          return !bundleComponent.data.texts.name1.includes(
                                            "["
                                          )
                                            ? _c(
                                                "article",
                                                {
                                                  staticClass:
                                                    "itemCategoryProduct horizontal",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "produkt_picture",
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              bundleComponent
                                                                .data.texts
                                                                .urlPath +
                                                              "_" +
                                                              bundleComponent
                                                                .data.variation
                                                                .itemId +
                                                              "_" +
                                                              bundleComponent
                                                                .data.variation
                                                                .id +
                                                              "/",
                                                            "aria-label":
                                                              "Paketbestandteil",
                                                            "click-count": "",
                                                          },
                                                        },
                                                        [
                                                          bundleComponent.data
                                                            .images.variation[0]
                                                            ? _c(
                                                                "picture",
                                                                {
                                                                  attrs: {
                                                                    "data-picture-class":
                                                                      "img-fluid",
                                                                    "data-loaded":
                                                                      "true",
                                                                  },
                                                                },
                                                                [
                                                                  _c("source", {
                                                                    attrs: {
                                                                      srcset:
                                                                        bundleComponent
                                                                          .data
                                                                          .images
                                                                          .variation[0]
                                                                          .urlPreview,
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "img-fluid",
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "productInfoContainer",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "productName",
                                                        },
                                                        [
                                                          _c("a", {
                                                            staticClass:
                                                              "thumb-title small",
                                                            attrs: {
                                                              href:
                                                                bundleComponent
                                                                  .data.texts
                                                                  .urlPath +
                                                                "_" +
                                                                bundleComponent
                                                                  .data
                                                                  .variation
                                                                  .itemId +
                                                                "_" +
                                                                bundleComponent
                                                                  .data
                                                                  .variation
                                                                  .id +
                                                                "/",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                bundleComponent.quantity +
                                                                  "x&nbsp;" +
                                                                  bundleComponent
                                                                    .data.texts
                                                                    .name1
                                                              ),
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          bundleComponent.data
                                                            .attributes
                                                            ? _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "variationHint",
                                                                },
                                                                _vm._l(
                                                                  bundleComponent
                                                                    .data
                                                                    .attributes,
                                                                  function (
                                                                    attribute
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-left",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    attribute
                                                                                      .attribute
                                                                                      .names
                                                                                      .name +
                                                                                      ": " +
                                                                                      attribute
                                                                                        .value
                                                                                        .names
                                                                                        .name
                                                                                  ),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "section",
                            { staticClass: "descriptionContainer" },
                            [
                              _c("div", { attrs: { id: "application" } }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-block text-left descriptionButton collapsed",
                                    attrs: {
                                      "data-toggle": "collapse",
                                      "data-target": "#applicationContainer",
                                      "aria-expanded": "false",
                                      "aria-controls": "applicationContainer",
                                      "aria-label": "Technische Daten",
                                      "click-count": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "icon-technicaldata",
                                        attrs: {
                                          viewBox: "0 0 24 24",
                                          width: "22",
                                          height: "22",
                                          stroke: "currentColor",
                                          "stroke-width": "1.5",
                                          fill: "none",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("circle", {
                                          attrs: { cx: "12", cy: "12", r: "3" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemTechnicalData"
                                          )
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      attrs: { "data-feather": "plus" },
                                    }),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "collapse",
                                  attrs: {
                                    id: "applicationContainer",
                                    "aria-labelledby": "more_details",
                                    "data-parent": "#rightSide",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "descriptionContent" },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-borderless table-sm",
                                        },
                                        [
                                          _c(
                                            "tbody",
                                            [
                                              _c("tr", [
                                                _c("th", [
                                                  _vm._v("Artikelnummer"),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.currentVariation.item
                                                        .id
                                                    ) +
                                                      "-" +
                                                      _vm._s(
                                                        _vm.currentVariation
                                                          .variation.id
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _vm.currentVariation.filter
                                                .hasManufacturer &&
                                              _vm.currentVariation.item
                                                .manufacturer.externalName !==
                                                ""
                                                ? _c("tr", [
                                                    _c("th", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Ceres::Template.singleItemManufacturer"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currentVariation
                                                            .item.manufacturer
                                                            .externalName
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.currentVariation.variation
                                                .weightG > 0
                                                ? _c("tr", [
                                                    _c("th", [
                                                      _vm._v("Gewicht"),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "ca. " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "numberFormat"
                                                            )(
                                                              _vm
                                                                .currentVariation
                                                                .variation
                                                                .weightG / 1000,
                                                              2,
                                                              ","
                                                            )
                                                          ) +
                                                          " kg"
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", [_vm._v("Pakete")]),
                                                _vm._v(" "),
                                                _vm.currentVariation.variation
                                                  .packingUnits > 0
                                                  ? _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currentVariation
                                                            .variation
                                                            .packingUnits
                                                        )
                                                      ),
                                                    ])
                                                  : _c("td", [_vm._v("1")]),
                                              ]),
                                              _vm._v(" "),
                                              _vm.techProperties.length > 0
                                                ? _vm._l(
                                                    _vm.techProperties,
                                                    function (vProperty) {
                                                      return _c("tr", [
                                                        _c("th", [
                                                          _vm._v(
                                                            _vm._s(
                                                              vProperty.name
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              vProperty.value
                                                            )
                                                          ),
                                                        ]),
                                                      ])
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.hasPropertySelection(166, 393)
                                                ? _c("tr", [
                                                    _c("th", [_vm._v("Vegan")]),
                                                    _vm._v(" "),
                                                    _c("td", [_vm._v("Ja")]),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.currentVariation.texts
                                              .technicalData
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.showResponsible &&
                                      !_vm.showManufacturer
                                        ? _vm._t("gpsr")
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showManufacturer
                            ? _c(
                                "section",
                                {
                                  staticClass: "descriptionContainer",
                                  attrs: { id: "manufacturerDetail" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-block text-left descriptionButton collapsed",
                                      attrs: {
                                        "data-toggle": "collapse",
                                        "data-target": "#manufacturer",
                                        "aria-expanded": "false",
                                        "aria-controls": "manufacturer",
                                        "aria-label":
                                          "Hersteller-Details: " +
                                          _vm.currentVariation.item.manufacturer
                                            .externalName,
                                        "click-count": "",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.currentVariation.item
                                            .manufacturer.logo,
                                          alt:
                                            "Marken-Logo-" +
                                            _vm.currentVariation.item
                                              .manufacturer.externalName,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.externalName
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        attrs: { "data-feather": "plus" },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "collapse mt-1",
                                      attrs: {
                                        id: "manufacturer",
                                        "aria-labelledby": "manufacturer",
                                        "data-parent": "#rightSide",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.currentVariation.item
                                            .manufacturer.logo,
                                          alt:
                                            "Logo " +
                                            _vm.currentVariation.item
                                              .manufacturer.externalName,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.comment
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn btn-block btn-sm btn-bkm",
                                          attrs: {
                                            href:
                                              "/markenwelt/" +
                                              _vm.currentVariation.item
                                                .manufacturer.url +
                                              "-" +
                                              _vm.currentVariation.item
                                                .manufacturer.id +
                                              "/",
                                            "aria-label":
                                              "Mehr Artikel von " +
                                              _vm.currentVariation.item
                                                .manufacturer.externalName,
                                            "click-count": "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Weiteres Sortiment entdecken "
                                          ),
                                          _c("i", {
                                            attrs: {
                                              "data-feather": "chevron-right",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showResponsible
                                        ? _vm._t("gpsr")
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("cross-selling-accessory"),
                          _vm._v(" "),
                          _vm.$store.getters.currentItemVariation
                            .variationProperties &&
                          _vm.$store.getters.currentItemVariation.variationProperties.filter(
                            function (prop) {
                              return prop.id == 4
                            }
                          )[0]
                            ? _vm._l(
                                _vm.$store.getters.currentItemVariation.variationProperties
                                  .filter(function (prop) {
                                    return prop.id == 4
                                  })[0]
                                  .properties.filter(function (prop) {
                                    return prop.id == 191
                                  }),
                                function (vProperty) {
                                  return _c(
                                    "section",
                                    { staticClass: "descriptionContainer" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-block text-left descriptionButton collapsed",
                                          attrs: {
                                            "data-toggle": "collapse",
                                            "data-target": "#careTaking",
                                            "aria-expanded": "false",
                                            "aria-controls": "careTaking",
                                            "aria-label": "Pflegehinweise",
                                            "click-count": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "icon-care",
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                width: "22",
                                                height: "22",
                                                stroke: "currentColor",
                                                "stroke-width": "1.5",
                                                fill: "none",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$translate(
                                                  "biokinderDesign::Template.itemCareAndUse"
                                                )
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "feather feather-plus",
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            },
                                            [
                                              _c("line", {
                                                attrs: {
                                                  x1: "12",
                                                  y1: "5",
                                                  x2: "12",
                                                  y2: "19",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("line", {
                                                attrs: {
                                                  x1: "5",
                                                  y1: "12",
                                                  x2: "19",
                                                  y2: "12",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "collapse",
                                          attrs: {
                                            id: "careTaking",
                                            "aria-labelledby": "more_details",
                                            "data-parent": "#rightSide",
                                          },
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "descriptionContent",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                vProperty.values.value
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.$attrs.availabilitydata
                                            .ourFurniture &&
                                          (_vm.color1 !== null ||
                                            _vm.color2 !== null)
                                            ? [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  _vm._l(
                                                    _vm.availableCareSets,
                                                    function (careSet) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-6",
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "careSet",
                                                              attrs: {
                                                                href: careSet.url,
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: careSet.image,
                                                                  alt:
                                                                    "Pflegeset " +
                                                                    careSet.name,
                                                                },
                                                              }),
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    careSet.name
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  )
                                }
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "section",
                            { staticClass: "descriptionContainer" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-block text-left descriptionButton collapsed",
                                  attrs: {
                                    "data-toggle": "collapse",
                                    "data-target": "#supportBox",
                                    "aria-expanded": "false",
                                    "aria-controls": "supportBox",
                                    "aria-label": "Sie haben Fragen?",
                                    "click-count": "",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-care",
                                    attrs: { "data-feather": "help-circle" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s("Sie haben Fragen?"),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "feather feather-plus",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    },
                                    [
                                      _c("line", {
                                        attrs: {
                                          x1: "12",
                                          y1: "5",
                                          x2: "12",
                                          y2: "19",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("line", {
                                        attrs: {
                                          x1: "5",
                                          y1: "12",
                                          x2: "19",
                                          y2: "12",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "collapse",
                                  attrs: {
                                    id: "supportBox",
                                    "aria-labelledby": "more_details",
                                    "data-parent": "#rightSide",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "descriptionContent" },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "Wir helfen Ihnen gerne! Rufen Sie uns an oder schreiben Sie uns eine Nachricht. Wir stehen Ihnen\n                    Montags bis Freitags von 8:00 bis 16:00 Uhr zur Verfügung und beraten Sie gerne."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._m(3),
                                      _vm._v(" "),
                                      _vm._m(4),
                                      _vm._v(" "),
                                      _c(
                                        "form",
                                        {
                                          staticClass: "row",
                                          attrs: { id: "12fd", method: "post" },
                                          on: {
                                            submit: function ($event) {
                                              $event.preventDefault()
                                              return _vm.$store.dispatch(
                                                "sendContactForm",
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "hidden",
                                              "data-mail": "recipient",
                                              value: "info@bio-kinder.de",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            attrs: {
                                              type: "hidden",
                                              "data-mail": "subject",
                                              value: "Frage zu Produkt",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-12 cmp-contact",
                                            },
                                            [
                                              _vm._m(5),
                                              _vm._v(" "),
                                              _vm._m(6),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "input-unit" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      name: "product",
                                                      disabled: "disabled",
                                                      type: "text",
                                                      id: "product",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.currentVariation
                                                          .item.id +
                                                        "-" +
                                                        _vm.currentVariation
                                                          .variation.id +
                                                        " " +
                                                        _vm.currentVariation
                                                          .texts.name1,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: { for: "product" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          Produkt\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._m(7),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass: "honey",
                                            attrs: {
                                              type: "text",
                                              name: "username",
                                              autocomplete: "new-password",
                                              tabindex: "-1",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-12 text-right",
                                            },
                                            [
                                              _c("recaptcha"),
                                              _vm._v(" "),
                                              _c("input", {
                                                staticClass:
                                                  "btn btn-bkm btn-sm btn-send-contact-form",
                                                attrs: {
                                                  type: "submit",
                                                  value: "Anfrage senden",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._t("additional-beaver-content"),
                    _vm._v(" "),
                    _vm.showChairTableSizeGuide
                      ? _vm._t("table-chair-size-guide")
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _vm._t("item-list-container"),
                          _vm._v(" "),
                          _vm._t("series-slide"),
                          _vm._v(" "),
                          _vm.currentVariation.variation.id != 8802
                            ? _vm._t("cross-selling-similar")
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "widget col-12",
                          attrs: { "data-feedback": "" },
                        },
                        [_vm._t("feedback-container")],
                        2
                      ),
                    ]),
                  ],
                  2
                ),
              ]
            ),
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField,
        }
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "button" }, [
      _c("i", { staticClass: "fa fa-play", attrs: { id: "playBtn" } }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-undo", attrs: { id: "resetBtn" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contents" }, [
      _c("div", { staticClass: "time" }, [
        _c("span", { staticClass: "elapsed", attrs: { id: "elapsedTime" } }, [
          _vm._v("0:00"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "seperator" }, [_vm._v(" / ")]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "totalLength", attrs: { id: "totalLength" } },
          [_vm._v("0:00")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "playLine" }, [
      _c("div", {
        staticClass: "playLineActive",
        attrs: { id: "playLineActive" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contactBox" }, [
      _c("p", [
        _c(
          "a",
          { attrs: { id: "phoneNumberLink", href: "tel:+4960814456315" } },
          [_vm._v("+49 (0) 6081 - 44 563 15")]
        ),
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("Mo. - Fr., 8:00 - 16:00 Uhr")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numItemsCol my-4 text-right" }, [
      _c("span", { staticClass: "numItems bg-white" }, [
        _vm._v("Anfrage per Mail:"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "input-unit mb-1 required",
        attrs: { "data-validate": "text" },
      },
      [
        _c("input", { attrs: { name: "name12", type: "text", id: "name12" } }),
        _vm._v(" "),
        _c("label", { attrs: { for: "name12" } }, [
          _vm._v(
            "\n                          Name *\n                        "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "widget-mail-input" }, [
      _c(
        "div",
        {
          staticClass: "input-unit mb-1 required",
          attrs: { "data-validate": "mail" },
        },
        [
          _c("input", {
            attrs: { name: "mail12", type: "email", id: "mail12" },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: {
              type: "hidden",
              "data-mail": "reply-to-address",
              value: "mail12",
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "mail12" } }, [
            _vm._v(
              "\n                            Ihre E-Mail Adrresse *\n                          "
            ),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "input-unit mb-1 required textarea",
        attrs: { "data-validate": "text" },
      },
      [
        _c("textarea", {
          staticClass: "no-resize",
          attrs: { name: "text12", id: "text12", rows: "4" },
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: "text12" } }, [
          _vm._v(
            "\n                          Ihre Anfrage *\n                        "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }